var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "vehicle-container" }, [
    _c("div", { staticClass: "vehicle" }, [
      _vm.vehicle
        ? _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { class: { "col-md-6": !_vm.hideBtn, "col-md-12": _vm.hideBtn } },
              [
                _c(
                  "span",
                  { staticClass: "d-block no-bottom-margin plate-number" },
                  [_c("b", [_vm._v(_vm._s(_vm.vehicle._plateNo))])]
                ),
                _vm.type == "vignette" && _vm.vehicle.category_vignette
                  ? _c("span", { staticClass: "d-block category" }, [
                      _c("b", [
                        _vm._v(_vm._s(_vm.vehicle.category_vignette.title)),
                      ]),
                    ])
                  : _vm._e(),
                _vm.type == "toll" && _vm.vehicle.category_toll
                  ? _c("span", { staticClass: "d-block category" }, [
                      _c("b", [
                        _vm._v(_vm._s(_vm.vehicle.category_toll.title)),
                      ]),
                    ])
                  : _vm._e(),
                _vm.vehicle._chasisNo
                  ? _c("span", { staticClass: "d-block category" }, [
                      _vm._v(_vm._s(_vm.vehicle._chasisNo)),
                    ])
                  : _vm._e(),
                _vm.vehicle.country.country
                  ? _c("span", { staticClass: "d-block category" }, [
                      _vm._v(_vm._s(_vm.vehicle.country.country)),
                    ])
                  : _vm._e(),
              ]
            ),
            !_vm.hideBtn
              ? _c(
                  "div",
                  {
                    staticClass:
                      "col-md-6 d-flex align-items-center mt-3 mt-md-0",
                  },
                  [
                    _vm.type == "vignette"
                      ? _c(
                          "router-link",
                          {
                            staticClass: "btn main-btn",
                            attrs: {
                              to: {
                                name: "vignette-category",
                                params: {
                                  id: _vm.vehicle.category_vignette.id,
                                  carId: _vm.vehicle.id,
                                },
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "fas fa-cart-plus" }),
                            _vm._v(" " + _vm._s(_vm.$t("vignette_buy")) + " "),
                          ]
                        )
                      : _vm._e(),
                    _vm.type == "toll"
                      ? _c(
                          "router-link",
                          {
                            staticClass: "btn main-btn",
                            attrs: {
                              to: {
                                name: "toll-category",
                                params: {
                                  id: _vm.vehicle._category_TPF,
                                  carId: _vm.vehicle.id,
                                },
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "fas fa-cart-plus" }),
                            _vm._v(" " + _vm._s(_vm.$t("toll_buy")) + " "),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }